import {LocalStorageKeys} from './local-storage.enum';

export abstract class AbstractLocalStorageService {

  abstract clear(key: LocalStorageKeys): void;

  abstract   get<T>(key: LocalStorageKeys): T;

  abstract   getSecured<T>(key: LocalStorageKeys): T | undefined;

  abstract write<T>(key: LocalStorageKeys, value: T): void;
}
